module.exports = __webpack_public_path__ + "static/media/logo.96e4d7db.png";